// extracted by mini-css-extract-plugin
export default {"appRoot":"App-module__appRoot--wscnf","messageassist":"App-module__messageassist--t5CQf","loadingBotText":"App-module__loadingBotText--oORbF"};